import { render } from "./EditPrintingProfile.vue?vue&type=template&id=e6c8c07a"
import script from "./EditPrintingProfile.vue?vue&type=script&lang=js"
export * from "./EditPrintingProfile.vue?vue&type=script&lang=js"

import "./EditPrintingProfile.vue?vue&type=style&index=0&id=e6c8c07a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__